import React from 'react'
import { Box } from 'components/Layout'
import { Tabs } from 'components/Tabs'
import { AddToFavoritesClientSignUp } from './AddToFavoritesClientSignUp'
import { AddToFavoritesExpertSignUp } from './AddToFavoritesExpertSignUp'

export const AddToFavoritesSignUp = ({
  setIsModalOpen,
}: {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const tabs = [
    {
      label: 'Clients',
      content: <AddToFavoritesClientSignUp setIsModalOpen={setIsModalOpen} />,
    },
    {
      label: 'Experts and Trade',
      content: <AddToFavoritesExpertSignUp setIsModalOpen={setIsModalOpen} />,
    },
  ]
  return (
    <Box>
      <Tabs.Root defaultValue={tabs[0].label}>
        <Tabs.List aria-label={`Manage sign in account `}>
          {tabs.map(({ label }) => (
            <Tabs.Tab value={label} key={label} aria-label={label}>
              {label}
            </Tabs.Tab>
          ))}
        </Tabs.List>
        {tabs.map(({ label, content }) => (
          <Tabs.Content value={label} key={label}>
            {content}
          </Tabs.Content>
        ))}
      </Tabs.Root>
    </Box>
  )
}
